export const StatusEffects = {
  FIRE: {
    name: "Fire",
    type: "fire",
    chance: 0.6,
    stacks: 3,
    stackDamage: 0.5,
    tickSpeed: 30,
  },
  BLEED: {
    name: "Bleed",
    type: "bleed",
    chance: 0.7,
    stacks: 2,
    stackDamage: 0.75,
    tickSpeed: 45,
  },
  POISON: {
    name: "Poison",
    type: "poison",
    chance: 0.5,
    stacks: 1,
    stackDamage: 1.0,
    tickSpeed: 60,
  },
  STUN: {
    name: "Stun",
    type: "stun",
    chance: 0.5,
    stacks: 1,
    stackDamage: 0,
    tickSpeed: 0,
    isTurnBased: true,
  },
};
